<template>
  <v-row align="center" no-gutters>
    <v-col cols="12">
      <v-textarea
        v-model="scriptCustomizado"
        class="mx-2"
        label="Script SQL Customizado"
        placeholder="Escreva aqui seu script SQL para atualização da BDGD"
        rows="10"
        no-resize
        clearable
      />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'ScriptCustomizado',
    data: () => ({
      scriptCustomizado: null
    }),
    watch: {
      scriptCustomizado() {
        this.$emit('parametrosScriptAtualizados', {
          script_customizado: this.scriptCustomizado
        });
      }
    }
  };
</script>
